var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75011 12.1293L4.14761 9.52683C4.00738 9.38659 3.81718 9.30781 3.61886 9.30781C3.42054 9.30781 3.23034 9.38659 3.09011 9.52683C2.94988 9.66706 2.87109 9.85726 2.87109 10.0556C2.87109 10.1538 2.89044 10.251 2.92801 10.3417C2.96559 10.4325 3.02067 10.5149 3.09011 10.5843L6.22511 13.7193C6.51761 14.0118 6.99011 14.0118 7.28261 13.7193L15.2176 5.78433C15.3578 5.64409 15.4366 5.4539 15.4366 5.25558C15.4366 5.05726 15.3578 4.86706 15.2176 4.72683C15.0774 4.58659 14.8872 4.50781 14.6889 4.50781C14.4905 4.50781 14.3003 4.58659 14.1601 4.72683L6.75011 12.1293Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check-icon.556c3e50cac241233b3820e5773e8776.svg";
export { ForwardRef as ReactComponent };